// ========================================
// ЭЛЕМЕНТЫ
// ========================================

// Сумма кредита
const totalCost = document.getElementById('total-cost');
const totalCostRange = document.getElementById('total-cost-range');

// Срок кредита
const creditTerm = document.getElementById('credit-term');
const creditTermRange = document.getElementById('credit-term-range');

// Ежемесячный платёж
const totalAmountOfCredit = document.getElementById('monthly-payment');

// Процентная ставка
const counterInput = document.getElementById('counter__input');


// ========================================
// РАСЧЁТ КРЕДИТА
// ========================================

const calculation = () => {

    const principal = Number(totalCost.value) || 0;
    const months = Number(creditTerm.value) || 1;
    const annualRate = Number(counterInput.value) || 0;

    // Месячная процентная ставка
    const monthlyRate = annualRate / 100 / 12;

    let monthlyPayment;

    // Если ставка 0%
    if (monthlyRate === 0) {

        monthlyPayment = principal / months;

    } else {

        // Аннуитетная формула
        monthlyPayment =
            principal *
            (
                monthlyRate *
                Math.pow(1 + monthlyRate, months)
            ) /
            (
                Math.pow(1 + monthlyRate, months) - 1
            );
    }

    // Вывод результата
    totalAmountOfCredit.innerHTML =
        `${monthlyPayment.toLocaleString('ru-RU', {
            maximumFractionDigits: 0
        })}<span>₽</span>`;
};


// ========================================
// RANGE → NUMBER
// ========================================

// Сумма кредита
totalCostRange.addEventListener('input', () => {

    totalCost.value = totalCostRange.value;

    calculation();

});


// Срок кредита
creditTermRange.addEventListener('input', () => {

    creditTerm.value = creditTermRange.value;

    calculation();

});


// ========================================
// NUMBER → RANGE
// ========================================

// Сумма кредита
totalCost.addEventListener('input', () => {

    // Пока пользователь вводит число,
    // ничего не ограничиваем
    if (totalCost.value !== '') {

        totalCostRange.value = totalCost.value;

        calculation();

    }

});


// Когда пользователь закончил ввод
totalCost.addEventListener('change', () => {

    let value = Number(totalCost.value);

    const min = Number(totalCostRange.min);
    const max = Number(totalCostRange.max);

    // Если поле пустое
    if (!totalCost.value || isNaN(value)) {
        value = min;
    }

    // Ограничиваем значение
    value = Math.max(min, Math.min(max, value));

    totalCost.value = value;
    totalCostRange.value = value;

    calculation();

});


// ========================================
// СРОК КРЕДИТА
// ========================================

creditTerm.addEventListener('input', () => {

    // Пока пользователь печатает,
    // не мешаем ему
    if (creditTerm.value !== '') {

        creditTermRange.value = creditTerm.value;

        calculation();

    }

});


creditTerm.addEventListener('change', () => {

    let value = Number(creditTerm.value);

    const min = Number(creditTermRange.min);
    const max = Number(creditTermRange.max);

    // Если поле пустое
    if (!creditTerm.value || isNaN(value)) {
        value = min;
    }

    // Ограничиваем значение
    value = Math.max(min, Math.min(max, value));

    creditTerm.value = value;
    creditTermRange.value = value;

    calculation();

});


// ========================================
// КНОПКИ + / -
// ========================================

const counters = document.querySelectorAll('[data-counter]');

counters.forEach(counter => {

    counter.addEventListener('click', (event) => {

        const button = event.target.closest('.counter__button');

        // Если нажали не на кнопку
        if (!button) {
            return;
        }

        let value = Number(counterInput.value);

        // Если значение некорректное
        if (isNaN(value)) {
            value = 12;
        }


        // ========================================
        // PLUS
        // ========================================

        if (button.classList.contains('counter__button_plus')) {
            value++;
        }


        // ========================================
        // MINUS
        // ========================================

        if (button.classList.contains('counter__button_minus')) {
            value--;
        }


        // ========================================
        // ОГРАНИЧЕНИЯ
        // ========================================

        const min = 1;
        const max = 44;

        value = Math.max(min, Math.min(max, value));


        // Записываем новое значение
        counterInput.value = value;


        // ========================================
        // DISABLED ДЛЯ КНОПОК
        // ========================================

        const minusButton =
            counter.querySelector('.counter__button_minus');

        const plusButton =
            counter.querySelector('.counter__button_plus');


        if (minusButton) {

            minusButton.classList.toggle(
                'disabled',
                value <= min
            );

        }


        if (plusButton) {

            plusButton.classList.toggle(
                'disabled',
                value >= max
            );

        }


        // Пересчитываем
        calculation();

    });

});


// ========================================
// НАЧАЛЬНОЕ СОСТОЯНИЕ
// ========================================

totalCostRange.value = totalCost.value;
creditTermRange.value = creditTerm.value;

calculation();
